// since gatsby does not support .ts for config,
// this file is just a wrapper loading the actual gatsby-browser.tsx file from src/setup
module.exports = require('./src/setup/gatsby-browser').gatsbyBrowser;
